// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../components/icons/PlusJakartaSans-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'PlusJakartaSans'; /* Choose a name for your font */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  /* Additional font properties can be specified, such as font-weight, font-style, etc. */
}

.analytics-main{
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 25px;
    /* background-color: #F6F8FA; */
    background-color: rgb(248, 248, 255);
        width: 100%;
        height: -webkit-fill-available;
        overflow-y: auto;               
  }
.legend {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 160px;
    overflow-y: auto;
    overflow-x: hidden; /* Ensure no horizontal scrolling */
    gap: 5px;
}

.calender-text{
    font-family: 'PlusJakartaSans';
    font-size: 14px;
    font-weight: 500;
    padding: 1px 7px;
}
.analytics-calender-div{
    position: absolute;
    display: flex;
    width: 330px;
    top: 110px;
}

.analytics-download-calender{
      display: flex;
    align-items: center;
    width: 160px;
    justify-content: center;
    border: 1px solid rgb(196, 196, 196);
    border-radius: 0.25rem;
    background-color: white;
    border-color: #c1b7b7;
    gap: 10px;
}
  .MuiSelect-outlined {
    padding: 1px 0px !important;

}
.select-text{
    font-family: 'PlusJakartaSans';
    font-size: 14px;
    font-weight: 500;
    padding: 7px;
}
  .analytics-violation-select{
    background-color: #fff !important;
  }
  .legend-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap:15px
  }
  
  .legend-color {
    width: 13px;
    height: 13px;
    margin-right: 4px;
    border-radius: 4px;
  }
  .Area-align{
    display: grid;
    height:140px;
    margin-top: 35px;
    grid-template-columns: repeat(3, 1fr);
    }

    .Area-align-two{
   display: grid;
    align-items: center;
    justify-content: center;
    margin-top: 35px;
    grid-template-columns: repeat(2, 1fr);
    }

      .Area-align-one{
          display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 35px;
    padding-left: 25px;
    padding-right: 25px;

  }
.area-main-block{
  display: flex;
  align-items: center;
}

.area-circle{
  width: 60px;
  height: 60px;
  color: white;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: xxx-large;
  font-weight: 600;
  font-family: ramaraja;
}

.area-text{
  font-family: PlusJakartaSans;
  font-size: 12px;
  font-weight: bold;

}
    .area-block{
      display: flex;
    flex-direction: column;
    align-items: center;
    gap:25px;
     width: 100%; /* Each area-block takes up the full width of its grid cell */
  box-sizing: border-box; /* Include padding and border in the width calculation */
  padding: 10px; 
    overflow: hidden; /* Hide any overflowed text */
  text-overflow: ellipsis; 
        white-space: nowrap; 

    }
  .google-visualization-legend {
    display: none !important;
  }
  .legend-label {
    font-size: 12px;
    font-weight: 600;
    font-family: PlusJakartaSans;
      white-space: nowrap; /* Prevent text from wrapping to the next line */
  overflow: hidden; /* Hide any overflowed text */
  text-overflow: ellipsis; 
  }
  
  .pie{
    display: contents;
  }

  .dropdown {
    width:150px;
  }

  .rmsc .dropdown-container {
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: small;
  }

  .filter{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap:15px
  }

  .align-center{
    display: grid;
    padding-left: 20px;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    align-items: center;
  }
  .datepicker{
    height: 25px;
    border-color: #c1b7b7;
    background-color:white;
    border:1px solid rgb(207, 207, 207);
    padding-left:0.25rem;
    padding-right:0.25rem; 
    padding-top:0.125rem;
    padding-bottom:0.125rem;
    border-radius:0.225rem; 
    font-family: 'PlusJakartaSans';
    font-size:x-small;
    font-weight: 500;                   
    width:7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap:0.5rem;
  }

  .down-arrow-icon{
    color: #AAA;
    font-size: small;
    stroke-width: 65px;
  }
.analytics-select{
  background-color: white;
      border-color: #c1b7b7;
}
  .calender-container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items:center;
    /* height:100%; */
    width:20%;
    position:absolute;
    left:22%;
    margin-top: 20px;
    z-index:99;
    background-color: white;
    
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
    font-family: 'PlusJakartaSans';
}

  .datepicker input {
    font-size: smaller !important;
  }

.dropdown-filter{
  display: flex;
  align-items: center;
  gap:15px
}

.button{
  width: 66px;
  height: 21.36px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PlusJakartaSans;
  font-size: 12px;
  font-weight: 500;
}

.analytics-big-card{
  margin-top: 25px;
  height: 230px;
  width: 65%;
  background: var(--Theme-Colors-White, #fff);
  border-radius: 4px !important;
  box-shadow: none !important;
  font-family: PlusJakartaSans; 
  padding-left: 25px;
  padding-right: 25px;
}

.analytics-small-card{
  margin-top: 25px;
  height: 230px;
  width: 35%;
  background: var(--Theme-Colors-White, #fff);
  border-radius: 4px !important;
  box-shadow: none !important;
  font-family: PlusJakartaSans; 
  padding-left: 25px;
  padding-right: 25px;
}

.analytics-main-card{
  display: flex;
  gap: 25px;
}

.analytics-header{
  font-family: PlusJakartaSans !important; 
    font-size: 16px !important;
    font-weight: bold !important;
    letter-spacing: 0em !important;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-top: 15px;
    margin-bottom: 0rem;

}
.report-dropdown-arrow-icon{
    transition: transform 0.3s ease;
    margin-right: 10px;
    transform:rotate(0deg);
    width: 20px;
    color:rgba(0, 0, 0, 0.87);
  }
@media screen and (max-width: 1800px) and (min-width: 1600px) {
.area-text{
  font-size:11px
}
.area-block {
  display: flex; /* Use flexbox */
  align-items: center; /* Vertically center the content */
  text-align: center; /* Center the text within the element */
  white-space: break-spaces; /* Allow breaking spaces */
  /* Optional: Add other styles like padding, margin, etc. */
}

}
@media screen and (max-width: 1600px) and (min-width: 1350px) {
.area-block {
  display: flex; /* Use flexbox */
  align-items: center; /* Vertically center the content */
  text-align: center; /* Center the text within the element */
  white-space: break-spaces; /* Allow breaking spaces */
  /* Optional: Add other styles like padding, margin, etc. */
}


  .align-center{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    align-items: center;
  }

}

@media screen and (max-width: 1350px) and (min-width: 1100px) {


  .align-center{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    align-items: center;
  }

}

`, "",{"version":3,"sources":["webpack://./src/pages/analytics/analytics.css"],"names":[],"mappings":"AACA;EACE,8BAA8B,EAAE,gCAAgC;EAChE,+DAA2F;EAC3F,uFAAuF;AACzF;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;IAC/B,oCAAoC;QAChC,WAAW;QACX,8BAA8B;QAC9B,gBAAgB;EACtB;AACF;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,kBAAkB,EAAE,mCAAmC;IACvD,QAAQ;AACZ;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,UAAU;AACd;;AAEA;MACM,aAAa;IACf,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,SAAS;AACb;EACE;IACE,2BAA2B;;AAE/B;AACA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;EACE;IACE,iCAAiC;EACnC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,qCAAqC;IACrC;;IAEA;GACD,aAAa;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,qCAAqC;IACrC;;MAEE;UACI,aAAa;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;;EAErB;AACF;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;;AAEnB;IACI;MACE,aAAa;IACf,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;KACP,WAAW,EAAE,6DAA6D;EAC7E,sBAAsB,EAAE,wDAAwD;EAChF,aAAa;IACX,gBAAgB,EAAE,6BAA6B;EACjD,uBAAuB;QACjB,mBAAmB;;IAEvB;EACF;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,4BAA4B;MAC1B,mBAAmB,EAAE,gDAAgD;EACzE,gBAAgB,EAAE,6BAA6B;EAC/C,uBAAuB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B;EACF;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,mCAAmC;IACnC,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;AACF;EACE,uBAAuB;MACnB,qBAAqB;AAC3B;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,UAAU;IACV,uBAAuB;;IAEvB,wCAAwC;IACxC,sBAAsB;IACtB,8BAA8B;AAClC;;EAEE;IACE,6BAA6B;EAC/B;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,2CAA2C;EAC3C,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,2CAA2C;EAC3C,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uCAAuC;IACrC,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;;AAEvB;AACA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,yBAAyB;EAC3B;AACF;AACA;EACE;AACF;AACA;EACE,aAAa,EAAE,gBAAgB;EAC/B,mBAAmB,EAAE,kCAAkC;EACvD,kBAAkB,EAAE,uCAAuC;EAC3D,yBAAyB,EAAE,0BAA0B;EACrD,0DAA0D;AAC5D;;AAEA;AACA;AACA;EACE,aAAa,EAAE,gBAAgB;EAC/B,mBAAmB,EAAE,kCAAkC;EACvD,kBAAkB,EAAE,uCAAuC;EAC3D,yBAAyB,EAAE,0BAA0B;EACrD,0DAA0D;AAC5D;;;EAGE;IACE,aAAa;IACb,qCAAqC;IACrC,uBAAuB;IACvB,mBAAmB;EACrB;;AAEF;;AAEA;;;EAGE;IACE,aAAa;IACb,qCAAqC;IACrC,uBAAuB;IACvB,mBAAmB;EACrB;;AAEF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');\r\n@font-face {\r\n  font-family: 'PlusJakartaSans'; /* Choose a name for your font */\r\n  src: url('../../components/icons/PlusJakartaSans-VariableFont_wght.ttf') format('truetype');\r\n  /* Additional font properties can be specified, such as font-weight, font-style, etc. */\r\n}\r\n\r\n.analytics-main{\r\n    padding-left: 25px;\r\n    padding-right: 25px;\r\n    padding-top: 25px;\r\n    /* background-color: #F6F8FA; */\r\n    background-color: rgb(248, 248, 255);\r\n        width: 100%;\r\n        height: -webkit-fill-available;\r\n        overflow-y: auto;               \r\n  }\r\n.legend {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    height: 160px;\r\n    overflow-y: auto;\r\n    overflow-x: hidden; /* Ensure no horizontal scrolling */\r\n    gap: 5px;\r\n}\r\n\r\n.calender-text{\r\n    font-family: 'PlusJakartaSans';\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    padding: 1px 7px;\r\n}\r\n.analytics-calender-div{\r\n    position: absolute;\r\n    display: flex;\r\n    width: 330px;\r\n    top: 110px;\r\n}\r\n\r\n.analytics-download-calender{\r\n      display: flex;\r\n    align-items: center;\r\n    width: 160px;\r\n    justify-content: center;\r\n    border: 1px solid rgb(196, 196, 196);\r\n    border-radius: 0.25rem;\r\n    background-color: white;\r\n    border-color: #c1b7b7;\r\n    gap: 10px;\r\n}\r\n  .MuiSelect-outlined {\r\n    padding: 1px 0px !important;\r\n\r\n}\r\n.select-text{\r\n    font-family: 'PlusJakartaSans';\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    padding: 7px;\r\n}\r\n  .analytics-violation-select{\r\n    background-color: #fff !important;\r\n  }\r\n  .legend-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap:15px\r\n  }\r\n  \r\n  .legend-color {\r\n    width: 13px;\r\n    height: 13px;\r\n    margin-right: 4px;\r\n    border-radius: 4px;\r\n  }\r\n  .Area-align{\r\n    display: grid;\r\n    height:140px;\r\n    margin-top: 35px;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    }\r\n\r\n    .Area-align-two{\r\n   display: grid;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 35px;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    }\r\n\r\n      .Area-align-one{\r\n          display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 35px;\r\n    padding-left: 25px;\r\n    padding-right: 25px;\r\n\r\n  }\r\n.area-main-block{\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.area-circle{\r\n  width: 60px;\r\n  height: 60px;\r\n  color: white;\r\n  border-radius: 30px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: xxx-large;\r\n  font-weight: 600;\r\n  font-family: ramaraja;\r\n}\r\n\r\n.area-text{\r\n  font-family: PlusJakartaSans;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n\r\n}\r\n    .area-block{\r\n      display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap:25px;\r\n     width: 100%; /* Each area-block takes up the full width of its grid cell */\r\n  box-sizing: border-box; /* Include padding and border in the width calculation */\r\n  padding: 10px; \r\n    overflow: hidden; /* Hide any overflowed text */\r\n  text-overflow: ellipsis; \r\n        white-space: nowrap; \r\n\r\n    }\r\n  .google-visualization-legend {\r\n    display: none !important;\r\n  }\r\n  .legend-label {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    font-family: PlusJakartaSans;\r\n      white-space: nowrap; /* Prevent text from wrapping to the next line */\r\n  overflow: hidden; /* Hide any overflowed text */\r\n  text-overflow: ellipsis; \r\n  }\r\n  \r\n  .pie{\r\n    display: contents;\r\n  }\r\n\r\n  .dropdown {\r\n    width:150px;\r\n  }\r\n\r\n  .rmsc .dropdown-container {\r\n    height: 25px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: small;\r\n  }\r\n\r\n  .filter{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap:15px\r\n  }\r\n\r\n  .align-center{\r\n    display: grid;\r\n    padding-left: 20px;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .datepicker{\r\n    height: 25px;\r\n    border-color: #c1b7b7;\r\n    background-color:white;\r\n    border:1px solid rgb(207, 207, 207);\r\n    padding-left:0.25rem;\r\n    padding-right:0.25rem; \r\n    padding-top:0.125rem;\r\n    padding-bottom:0.125rem;\r\n    border-radius:0.225rem; \r\n    font-family: 'PlusJakartaSans';\r\n    font-size:x-small;\r\n    font-weight: 500;                   \r\n    width:7rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap:0.5rem;\r\n  }\r\n\r\n  .down-arrow-icon{\r\n    color: #AAA;\r\n    font-size: small;\r\n    stroke-width: 65px;\r\n  }\r\n.analytics-select{\r\n  background-color: white;\r\n      border-color: #c1b7b7;\r\n}\r\n  .calender-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    align-items:center;\r\n    /* height:100%; */\r\n    width:20%;\r\n    position:absolute;\r\n    left:22%;\r\n    margin-top: 20px;\r\n    z-index:99;\r\n    background-color: white;\r\n    \r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    border-radius: 0.25rem;\r\n    font-family: 'PlusJakartaSans';\r\n}\r\n\r\n  .datepicker input {\r\n    font-size: smaller !important;\r\n  }\r\n\r\n.dropdown-filter{\r\n  display: flex;\r\n  align-items: center;\r\n  gap:15px\r\n}\r\n\r\n.button{\r\n  width: 66px;\r\n  height: 21.36px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-family: PlusJakartaSans;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.analytics-big-card{\r\n  margin-top: 25px;\r\n  height: 230px;\r\n  width: 65%;\r\n  background: var(--Theme-Colors-White, #fff);\r\n  border-radius: 4px !important;\r\n  box-shadow: none !important;\r\n  font-family: PlusJakartaSans; \r\n  padding-left: 25px;\r\n  padding-right: 25px;\r\n}\r\n\r\n.analytics-small-card{\r\n  margin-top: 25px;\r\n  height: 230px;\r\n  width: 35%;\r\n  background: var(--Theme-Colors-White, #fff);\r\n  border-radius: 4px !important;\r\n  box-shadow: none !important;\r\n  font-family: PlusJakartaSans; \r\n  padding-left: 25px;\r\n  padding-right: 25px;\r\n}\r\n\r\n.analytics-main-card{\r\n  display: flex;\r\n  gap: 25px;\r\n}\r\n\r\n.analytics-header{\r\n  font-family: PlusJakartaSans !important; \r\n    font-size: 16px !important;\r\n    font-weight: bold !important;\r\n    letter-spacing: 0em !important;\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    padding-top: 15px;\r\n    margin-bottom: 0rem;\r\n\r\n}\r\n.report-dropdown-arrow-icon{\r\n    transition: transform 0.3s ease;\r\n    margin-right: 10px;\r\n    transform:rotate(0deg);\r\n    width: 20px;\r\n    color:rgba(0, 0, 0, 0.87);\r\n  }\r\n@media screen and (max-width: 1800px) and (min-width: 1600px) {\r\n.area-text{\r\n  font-size:11px\r\n}\r\n.area-block {\r\n  display: flex; /* Use flexbox */\r\n  align-items: center; /* Vertically center the content */\r\n  text-align: center; /* Center the text within the element */\r\n  white-space: break-spaces; /* Allow breaking spaces */\r\n  /* Optional: Add other styles like padding, margin, etc. */\r\n}\r\n\r\n}\r\n@media screen and (max-width: 1600px) and (min-width: 1350px) {\r\n.area-block {\r\n  display: flex; /* Use flexbox */\r\n  align-items: center; /* Vertically center the content */\r\n  text-align: center; /* Center the text within the element */\r\n  white-space: break-spaces; /* Allow breaking spaces */\r\n  /* Optional: Add other styles like padding, margin, etc. */\r\n}\r\n\r\n\r\n  .align-center{\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n}\r\n\r\n@media screen and (max-width: 1350px) and (min-width: 1100px) {\r\n\r\n\r\n  .align-center{\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
